import MeterUnitRecord from "../../../utils/services/project/metering/meterUnitRecordService";
import crudTemplate from "../../../templates/crudTemplate";
let crud = crudTemplate(MeterUnitRecord);
function prepareItem(i, tariffs) {
  i.tariff_name = "";
  if (i._tariff && i._tariff.id) {
    i.tariff_id = i._tariff.id;
    i.tariff = tariffs.find(u => u.id === i.tariff_id);
    i.tariff_name = (i.tariff || {}).name;
  }
  return i;
}
const state = {
  ...crud.state
};
const getters = {
  ...crud.getters,
  getList(state, getters, rootState, rootGetters) {
    let list = crud.getters.getList(state);
    let tariffs = rootGetters["projectMeteringStore/tariffStore/getList"];
    return list.map(i => prepareItem(i, tariffs));
  }
};

const actions = {
  ...crud.actions,
  massDeleteRecords(
    _,
    {
      params,
      errorHandler = () => {},
      onError = () => {},
      onSuccess = () => {}
    }
  ) {
    return MeterUnitRecord.massDeleteRecords(
      { ...params },
      onSuccess,
      onError,
      errorHandler
    );
  },
  async export(_, { params = {} }) {
    let clearance = await MeterUnitRecord.clearance();
    return MeterUnitRecord.export({
      ...params,
      clearance
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
